<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>评价系统</el-breadcrumb-item>
      <el-breadcrumb-item>成绩查询</el-breadcrumb-item>
      <el-breadcrumb-item>成绩列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <!-- 成绩列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span>成绩列表</span>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="#" type="index" width="60"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="总分" prop="totalScore" width="120">
          <template slot-scope="scope">
            <span class="total-score">{{ scope.row.totalScore }}</span>
          </template>
        </el-table-column>
        <el-table-column label="过程性评价得分" prop="processScore"></el-table-column>
        <el-table-column label="过程性评价折算得分" prop="processConvertScore"></el-table-column>
        <el-table-column label="终结性评价得分" prop="summativeScore"></el-table-column>
        <el-table-column label="终结性评价折算得分" prop="summativeConverScore"></el-table-column>
        <el-table-column label="点评" prop="review" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleAudit(scope.row)"
            >过程性评价</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleAudit(scope.row)"
            >终结性评价</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getScoreListByPblTeamId } from '@/http/api'

export default {
  data () {
    return {
      // 项目信息列表点击数据的主键 id，由路由携带
      id: this.$route.query.id || '',
      dataList: []
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取成绩列表
    getDataList () {
      getScoreListByPblTeamId({ id: this.id }).then((res) => {
        console.log('getScoreListByPblTeamId', res)
        const data = res.data
        this.dataList = Array.isArray(data) ? data : (data && data.list) || []
      }).catch((err) => {
        console.log('err', err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.total-score{
  color: orange;
  font-weight: bold;
  font-size: 16px;
}
</style>
